/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../../../components/ui-elements/loader';
import { useCallback } from 'react';
import { getAllSplunkUsers } from '../../../../../store/reducers/splunk/splunkAction';
import RefreshIcon from "@mui/icons-material/Refresh";
import DeleteSplunkUser from './DeleteSplunkUser';

const SplunkUsersList = () => {
      const [loading, setLoading] = useState(false);
 
 
    const dispatch = useDispatch();
    const users = useSelector(state => state.splunk.splunkUsersList);

    const fetchSplunk = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllSplunkUsers()).unwrap();
        } finally {
            setLoading(false);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchSplunk();
    }, [fetchSplunk]);

 

    return (
        <>
            {!loading ? (
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell label="Name" />
                               
                                <StyledTableCell label=" " align="right">
                                    <IconButton onClick={fetchSplunk} color="secondary"  >
                                        <RefreshIcon sx={{ fontSize: 30 }} />
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(users?.entry) && users?.entry.length > 0 && users?.entry.map((row) => (
                                <>

                                    <StyledTableRow key={row.id}>
                                        <StyledTableCell label={row.name} />
                                        <StyledTableCell>
                                            <DeleteSplunkUser id={row.id} name={row.name} />

                                        </StyledTableCell>

                                    </StyledTableRow>
                                </>))}

                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <Loader />
            )}

 
          
        </>
    );
};

export default SplunkUsersList;